<template>
	<div class="accordion-container" :open="open" :bottomBorder="bottomBorder">
		<div class="accordion-header">
			<slot name="header" />
		</div>
		<div class="accordion-body-wrapper" :style="bodyStyle" @transitionend="$emit('transitionend')">
			<div ref="accBody" :open="open" class="accordion-body">
				<slot />
			</div>
		</div>
	</div>
</template>
<script lang="ts">
import { defineComponent } from "vue";
/**
 * Accordion is a vertically stacked list of headers. Each header can expand or collapse based on user’s interaction with the header to reveal or hide the content of it. Accordions are helpful for progressive disclosure of the information especially When the space on the interface is limited.
 */
export default defineComponent({
	name: "Accordion",

	props: {
		/**
		 * True/False to open or close accordion
		 */
		open: {
			type: Boolean,
			default: false
		},

		bottomBorder: {
			type: Boolean,
			default: false
		}
	},

	emits: ["transitionend"],

	data() {
		return {
			updateHeightCount: 0,
			observer: null as MutationObserver | null,
			resizeObserver: null as ResizeObserver | null
		};
	},

	computed: {
		bodyStyle() {
			if (!this.updateHeightCount) {
				return;
			}
			return {
				height: this.open ? `${this.getAccBody().offsetHeight}px` : "0px"
			};
		}
	},

	mounted() {
		// need this flag to use in computed properties
		this.updateHeightCount = 1;

		this.observer = new MutationObserver(() => {
			this.updateHeightCount += 1;
		});

		this.observer.observe(this.getAccBody(), {
			attributes: false,
			childList: true,
			subtree: true
		});

		this.resizeObserver = new ResizeObserver(() => {
			this.updateHeightCount += 1;
		});

		this.resizeObserver.observe(this.getAccBody(), {
			box: "border-box"
		});
	},

	beforeDestroy() {
		this.observer?.disconnect();
		this.resizeObserver?.disconnect();
	},

	methods: {
		getAccBody() {
			return this.$refs.accBody as HTMLDivElement;
		}
	}
});
</script>

<style lang="scss">
@mixin accordion-mixin($border, $open-icon-color) {
	div.accordion-container {
		&[open] {
			> div.accordion-header {
				// border-bottom: none;
				> div.slab-hierarchy > div.slab-container div.icon-container[name="chevron"] svg {
					stroke: $open-icon-color;
				}
			}
		}
		> div.accordion-header {
			// border-bottom: 1px solid $border;
		}
		&[bottomBorder] {
			border-bottom: 1px solid $border;
		}
	}
}

div.accordion-container {
	> div.accordion-header {
		> div.slab-hierarchy > div.slab-container {
			min-height: 56px;

			> div.slab-content {
				> div.slab-title {
					font-size: 12px;
					font-weight: bold;
					text-transform: uppercase;
				}
			}
		}
	}

	> div.accordion-body-wrapper {
		overflow: hidden;
		transition: height 0.5s ease-out;
		> div.accordion-body {
			overflow: hidden;

			// transform: translateY(-100%);

			// transition: transform 0.5s ease-out;

			&[open] {
				// transform: translateY(0%);
				overflow-y: auto;
				height: auto;
			}
			> div.v-menu-container {
				padding-bottom: 0px;
			}

			> div.slab-hierarchy {
				padding-left: 36px;

				div.slab-container {
					min-height: 56px;
				}
			}

			div.slab-hierarchy + div.slab-hierarchy:last-child {
				div.slab-container {
					border-bottom: none;
				}
			}
		}
	}
}

div.sideout-container {
	@include accordion-mixin(var(--slideout-borde-light), var(--slideout-primary));
}

@include accordion-mixin(var(--dashboard-border-light), var(--dashboard-primary));
</style>
